import {NgModule} from '@angular/core';
import {RouterModule, Routes} from '@angular/router';
import {MatButtonModule} from '@angular/material/button';
import {MatIconModule} from '@angular/material/icon';
import {PristineSharedModule} from '@pristinebase/shared.module';
import {PristineWidgetModule} from '@pristinebase/components/widget/widget.module';
import {MatCardModule} from "@angular/material/card";
import {MatProgressBarModule} from "@angular/material/progress-bar";
import {MatRippleModule} from "@angular/material/core";
import {AttendanceComponent} from "./attendance.component";
import {MatListModule} from "@angular/material/list";
import {MatExpansionModule} from "@angular/material/expansion";
import {MatDialogModule} from "@angular/material/dialog";
import {MatRadioModule} from "@angular/material/radio";
import { AttendencePopUpComponent } from './attendence-pop-up/attendence-pop-up.component';
import {MatFormFieldModule} from "@angular/material/form-field";
import {MatSelectModule} from "@angular/material/select";
import {MatInputModule} from "@angular/material/input";

const routes: Routes = [
    {
        path: 'attendance',
        component: AttendanceComponent,
    }
];

@NgModule({
    declarations: [
        AttendanceComponent,
        AttendencePopUpComponent
    ],
    imports: [
        RouterModule.forChild(routes),
        MatButtonModule,
        MatIconModule,
        PristineSharedModule,
        PristineWidgetModule,
        MatCardModule,
        MatProgressBarModule,
        MatRippleModule,
        MatListModule,
        MatExpansionModule,
        MatDialogModule,
        MatRadioModule,
        MatFormFieldModule,
        MatSelectModule,
        MatInputModule
    ],
    exports: [AttendanceComponent]
})
export class AttendanceModule {
}

